module.exports = __webpack_public_path__ + "media/images/app_icon-6f8aeeab5854c0eb6013b5ff8ffa4b1c.png";